// ── Extracted screen function ───────────────────────────────────────

export function drawTrapFxOverlayScreen(
  ctx: CanvasRenderingContext2D,
  kind: string,
  ageSec: number,
  px: number, py: number, size: number,
  nowSec: number
): void {
  const duration = 3;
  const t = Math.min(1, ageSec / duration); // 0→1 over duration
  const fadeAlpha = 1 - t * t; // ease-out fade

  ctx.save();

  switch (kind) {
    case "FOG_OVERLAY": {
      // Thick hazy fog — dense drifting clouds
      ctx.globalAlpha = fadeAlpha;
      for (let i = 0; i < 12; i++) {
        const phase = i * 0.79 + nowSec * 0.5;
        const cx = px + size * 0.3 + Math.sin(phase) * size * 0.4;
        const cy = py + size * 0.3 + Math.cos(phase * 0.7 + i) * size * 0.35;
        const r = size * (0.18 + 0.12 * Math.sin(phase * 0.5));
        const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
        grad.addColorStop(0, "rgba(200,220,240,0.85)");
        grad.addColorStop(0.6, "rgba(150,175,200,0.4)");
        grad.addColorStop(1, "rgba(100,130,160,0)");
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fill();
      }
      break;
    }
    case "LOCKDOWN_CHAINS": {
      // Heavy chain links criss-crossing over the portrait
      ctx.globalAlpha = fadeAlpha;
      ctx.strokeStyle = "#c0ccdd";
      ctx.lineWidth = 4;
      ctx.shadowColor = "#ffffff";
      ctx.shadowBlur = 12;
      const shake = Math.sin(nowSec * 14) * 3 * fadeAlpha;
      for (let i = 0; i < 5; i++) {
        const y1 = py + size * (0.1 + i * 0.2);
        ctx.beginPath();
        ctx.moveTo(px - 15, y1 + shake);
        ctx.lineTo(px + size + 15, y1 - shake);
        ctx.stroke();
      }
      // Diagonal cross chains
      ctx.lineWidth = 3.5;
      ctx.beginPath();
      ctx.moveTo(px, py + shake);
      ctx.lineTo(px + size, py + size - shake);
      ctx.moveTo(px + size, py + shake);
      ctx.lineTo(px, py + size - shake);
      ctx.stroke();
      ctx.shadowBlur = 0;
      break;
    }
    case "COIN_TAX": {
      // Gold coins raining down with glow
      ctx.globalAlpha = fadeAlpha;
      for (let i = 0; i < 14; i++) {
        const seed = i * 1.37;
        const cx = px + size * (0.05 + 0.9 * ((seed * 7.13) % 1));
        const fallT = (ageSec * 1.5 + seed * 0.3) % 2;
        const cy = py + size * fallT * 0.55;
        const coinR = 5 + 3 * Math.sin(seed);
        const spin = nowSec * 4 + seed;
        const scaleX = Math.abs(Math.cos(spin));
        ctx.save();
        ctx.translate(cx, cy);
        ctx.scale(scaleX, 1);
        ctx.shadowColor = "#ffdd00";
        ctx.shadowBlur = 8;
        ctx.beginPath();
        ctx.arc(0, 0, coinR, 0, Math.PI * 2);
        ctx.fillStyle = "#ffd700";
        ctx.fill();
        ctx.strokeStyle = "#bb8800";
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.shadowBlur = 0;
        ctx.restore();
      }
      break;
    }
    case "GROOVE_DRAIN": {
      // Bold purple energy draining upward
      ctx.globalAlpha = fadeAlpha;
      for (let i = 0; i < 16; i++) {
        const seed = i * 2.17;
        const x = px + size * ((seed * 5.31) % 1);
        const riseT = (ageSec * 2 + seed * 0.2) % 1.5;
        const y = py + size - riseT * size * 0.85;
        const sparkR = 3 + Math.sin(nowSec * 5 + seed) * 2;
        const grad = ctx.createRadialGradient(x, y, 0, x, y, sparkR * 4);
        grad.addColorStop(0, "rgba(220,130,255,1)");
        grad.addColorStop(0.4, "rgba(180,80,255,0.6)");
        grad.addColorStop(1, "rgba(120,50,200,0)");
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(x, y, sparkR * 4, 0, Math.PI * 2);
        ctx.fill();
      }
      break;
    }
    case "DOOM_SURGE": {
      // Intense red pulsing danger rings expanding outward
      ctx.globalAlpha = fadeAlpha;
      const cx = px + size / 2;
      const cy = py + size / 2;
      for (let ring = 0; ring < 4; ring++) {
        const ringT = ((ageSec * 1.4 + ring * 0.35) % 1.2);
        const radius = ringT * size * 0.55;
        const ringAlpha = Math.max(0, 1 - ringT / 1.2) * fadeAlpha;
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(255,40,40,${ringAlpha.toFixed(3)})`;
        ctx.lineWidth = 4 - ringT * 2;
        ctx.shadowColor = "#ff0000";
        ctx.shadowBlur = 10;
        ctx.stroke();
        ctx.shadowBlur = 0;
      }
      // Bright central flash
      const flashR = size * 0.2 * (1 + 0.4 * Math.sin(nowSec * 10));
      const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, flashR);
      grad.addColorStop(0, `rgba(255,100,100,${fadeAlpha.toFixed(3)})`);
      grad.addColorStop(0.5, `rgba(255,40,40,${(fadeAlpha * 0.5).toFixed(3)})`);
      grad.addColorStop(1, "rgba(255,20,20,0)");
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(cx, cy, flashR, 0, Math.PI * 2);
      ctx.fill();
      break;
    }
    default:
      break;
  }

  ctx.restore();
}
